const SHADOW_PARTS = [
  '14.06px 14.06px 12.8457px rgb(0 0 0 / 7%)',
  '7.68px 7.68px 7.74008px rgb(0 0 0 / 12%)',
  '3.39px 3.39px 4.31018px rgb(0 0 0 / 16%)',
  '0.32px 0.32px 1.85378px rgb(0 0 0 / 5%)',
]

const INVERSE_HIGHLIGHT_PARTS = [
  '-7.68px -7.68px 7.74008px rgb(0 0 0 / 6%)',
  '-3.39px -3.39px 4.31018px rgb(0 0 0 / 8%)',
  '-0.32px -0.32px 1.85378px rgb(0 0 0 / 2.5%)',
]

export function getFrameShadow() {
  return `${SHADOW_PARTS.join(', ')};`
}

export function getInverseFrameHighlight() {
  return INVERSE_HIGHLIGHT_PARTS.join(', ')
}
